// extracted by mini-css-extract-plugin
export default {"form":"hx6VhnMeZJ9u2lASdIxf","descriptionRow":"JP4_tcVGTtcSCAM8_55K"};